"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.message = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var classNames = require("classnames");
var MessageAction_1 = require("@/pages/common/actions/MessageAction");
var mapStateToProps = function (state) { return (__assign(__assign({}, state.message), { t: state.translate })); };
var mapDispatchToProps = function (dispatch) { return ({
    messageClose: function () { return dispatch(MessageAction_1.default.messageClose()); },
}); };
exports.message = function (props) {
    var messageClass = classNames([
        'c-notify',
        {
            'u-hidden': !props.active,
            'c-notify--warning': props.warningLevel === 1
        },
    ]);
    var onBodyClicked = function () {
        if (!props.actionText) {
            props.messageClose();
        }
    };
    return (React.createElement("div", { id: "messagesection", className: messageClass, onClick: onBodyClicked },
        props.title ? (React.createElement("div", { className: "c-notify__icon" },
            React.createElement("span", { className: "fal fa-exclamation-triangle" }))) : null,
        React.createElement("div", { className: "c-notify__body" },
            props.title ? (React.createElement("div", { className: "c-notify__title" }, props.title)) : null,
            React.createElement("div", { className: "c-notify__text", dangerouslySetInnerHTML: { __html: props.message } })),
        props.actionText ? (React.createElement("div", { className: "c-notify__action" },
            React.createElement("a", { className: "o-btn o-btn--flat", target: "_blank", href: props.actionUrl }, props.actionText))) : null,
        React.createElement("div", { onClick: props.messageClose, className: "c-notify__close" },
            React.createElement("span", { className: "fal fa-times" }))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.message);
